import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { StyledTitle } from './StyledComponents';
import ActionsSection from './ActionsSection';

export const StyledQRTitle = styled(StyledTitle)`
  text-align: left;
  padding-left: ${scaleSize(170)}px;
  margin: ${scaleSize(55)}px 0;
`;

export const StyledQRBlock = styled.div`
  display: inline-block;
  box-sizing: border-box;
  text-align: center;
  width: ${scaleSize(1070)}px;
  padding: ${scaleSize(40)}px ${scaleSize(100)}px;
`;

export const QRDescription = styled.div`
  font-family: RobotoMedium, sans-serif;
  font-size: ${scaleSize(32)}px;
  text-align: center;
  line-height: 1.3;
  color: ${({ theme }) => theme.mainTextColor};
`;

export const QRLink = styled.div`
  font-family: RobotoRegular, sans-serif;
  font-size: ${scaleSize(48)}px;
  line-height: 1.7;
  text-align: center;
  letter-spacing: -0.222222px;
  color: ${({ theme }) => theme.defaultColor};
`;

export const QRCodeWrapper = styled.div`
  display: inline-block;
  background: ${({ theme }) => theme.defaultColor};
  margin: ${scaleSize(70)}px 0 ${scaleSize(90)}px;
  padding: ${scaleSize(16)}px;
  height: ${scaleSize(300)}px;
  width: ${scaleSize(300)}px;
`;

export const RetryTextWrapper = styled.div`
  display: inline-block;
  margin: ${scaleSize(80)}px 0;
  padding: ${scaleSize(16)}px;
  height: ${scaleSize(300)}px;
  width: ${scaleSize(620)}px;

  svg {
    margin-top: ${scaleSize(50)}px;
  }

  p {
    font-family: RobotoMedium, sans-serif;
    font-size: ${scaleSize(28)}px;
    line-height: ${scaleSize(39)}px;
    text-align: center;
    color: ${({ theme }) => theme.iconDefaultColor};
  }
`;

export const StyledCodeBlock = styled.div`
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
  width: ${scaleSize(760)}px;
  padding-top: ${scaleSize(60)}px;
`;

export const CodeTitle = styled.div`
  font-family: RobotoMedium, sans-serif;
  text-align: center;
  font-size: ${scaleSize(32)}px;
  line-height: ${scaleSize(39)}px;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.defaultColor};
  padding-top: ${scaleSize(160)}px;
  box-sizing: border-box;
`;

export const UserCode = styled.div`
  font-family: RobotoMedium, sans-serif;
  font-size: ${({ isCodeExpired }) => (isCodeExpired ? scaleSize(80) : scaleSize(100))}px;
  line-height: ${scaleSize(72)}px;
  padding-top: ${scaleSize(50)}px;
  text-align: center;
  letter-spacing: -0.333333px;
  color: ${({ theme, isCodeExpired }) => (isCodeExpired ? theme.secondaryTextColor : theme.defaultColor)};
`;

export const StyledActionSection = styled(ActionsSection)`
  margin-top: ${scaleSize(80)}px;
`;

export const StyledButton = styled(ActionsSection.Button)`
  opacity: ${({ $disabled }) => ($disabled ? '0.5' : 1)};
`;

export const StyledTimer = styled.div`
  font-family: RobotoRegular, sans-serif;
  font-size: ${scaleSize(32)}px;
  line-height: 1.5;
  text-align: center;
  letter-spacing: -0.222222px;
  color: ${({ theme }) => theme.defaultColor};
`;
